import { useAtom } from "jotai";

import { VideoAdsQuizWidget } from "../video-ads-quiz/video-ads-quiz.component";

import { LanderCplQuizBody } from "./components/lander-cpl-quiz-body/lander-cpl-quiz-body.component";
import { LanderCplQuizFooter } from "./components/lander-cpl-quiz-footer/lander-cpl-quiz-footer.component";
import { LanderCplQuizHeader } from "./components/lander-cpl-quiz-header/lander-cpl-quiz-header.component";
import { landerCplQuizAtom } from "./lander-cpl-quiz.state";

declare global {
  interface FKL {
    skipLanderCplQuiz: boolean;
  }
}

export function Widget() {
  const [landerCplQuiz] = useAtom(landerCplQuizAtom);
  const {
    afterLanderCplQuiz,
    donationsAsFirstStep: isDonationFirstStep,
    skipVideoAdsQuiz,
  } = window.FKL;

  const shouldSkipLanderQuiz =
    !landerCplQuiz.is_valid || afterLanderCplQuiz || isDonationFirstStep;

  const renderLanderCplQuiz = (): JSX.Element => (
    <div className="lander-cpl-quiz-widget">
      <LanderCplQuizHeader />
      <LanderCplQuizBody />
      <LanderCplQuizFooter />
    </div>
  );

  if (skipVideoAdsQuiz && shouldSkipLanderQuiz) {
    window.theme.LanderCplQuizUtils.handleVideoAdsQuizNextSweepStep();
    return null;
  }

  if (skipVideoAdsQuiz && !shouldSkipLanderQuiz) {
    return renderLanderCplQuiz();
  }

  return (
    <>
      {shouldSkipLanderQuiz ? (
        <div className="lander-cpl-quiz-widget">
          <VideoAdsQuizWidget />
        </div>
      ) : (
        renderLanderCplQuiz()
      )}
    </>
  );
}
